
































































































































import {Vue, Component} from 'vue-property-decorator';
import {ReportModel} from "@/views/Izvestaji/Merchandisers/MesecniMerchandisingIzvestaj/ReportModel";
import {mixins} from "vue-class-component";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";

@Component({})
export default class MesecniMerchandisingIzvestaj extends mixins(ComponentBaseMixin) {
  years = [];
  months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  selectedYear: any = '';
  selectedMonth: any = '';
  isBusy = false;

  report = new ReportModel();

  created() {
    let currentYear = new Date().getFullYear();
    let startYear = 2015;
    while (startYear <= currentYear) {
      this.years.push(startYear++);
    }
    this.selectedYear = new Date().getFullYear();
    this.selectedMonth = new Date().getMonth();
  }

  async getReport() {
    this.isBusy = true;
    await this.axios.get('api/reports/monthlyTeamReport', {
      params: {
        year: this.selectedYear,
        month: this.selectedMonth
      }
    }).then(result => {
      this.report = result.data;
    }).catch(err => {
      this.showError('greskaPrilikomUcitavanja');
      this.isBusy = false;
    }).finally(() => {
      this.isBusy = false;
    })
  }

}
